import { render, staticRenderFns } from "./ValidatePanel.vue?vue&type=template&id=0722e36d&scoped=true&"
import script from "./ValidatePanel.vue?vue&type=script&lang=js&"
export * from "./ValidatePanel.vue?vue&type=script&lang=js&"
import style0 from "./validatePanel.scss?vue&type=style&index=0&id=0722e36d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0722e36d",
  null
  
)

export default component.exports